import { LiturgyItem } from "./types";

export const getComplineResponsory = (): LiturgyItem[] => {
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "In",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "to",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hands,",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5", "4", "4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "mend",
                                        notes: ["4", "3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "In",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "to",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hands,",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5", "4", "4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "mend",
                                        notes: ["4", "3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "For",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hast",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "re",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "deem",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ed",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "me,",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "God",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "of",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "truth.",
                                        notes: ["5", "4", "4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "mend",
                                        notes: ["4", "3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Glo",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ry",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Fa",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ther,",
                                        notes: ["5"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: ["5", "6b"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Son,",
                                        notes: ["5"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Ho",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ly",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Ghost.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "In",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "to",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hands,",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["5", "4", "4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "mend",
                                        notes: ["4", "3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Keep",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "me,",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "as",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "app",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "le",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "of",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "eye.",
                                        notes: [
                                            "6",
                                            "7",
                                            "6",
                                            "5",
                                            "4",
                                            "5",
                                            "7",
                                            "6",
                                            "5",
                                        ],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Hide",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "me",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "un",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "der",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "shad",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ow",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "of",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "wings.",
                                        notes: [
                                            "6",
                                            "7",
                                            "6",
                                            "5",
                                            "4",
                                            "5",
                                            "7",
                                            "6",
                                            "5",
                                        ],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    ];
};
